export const Brand_AzureDevops = `<svg title="Brand_AzureDevops" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
<rect width="24" height="24" fill="#E6F6FF"/>
<path d="M20 7V16.74L16 20.02L9.8 17.76V20L6.29 15.41L16.52 16.21V7.44L20 7ZM16.59 7.49L10.85 4V6.29L5.58 7.84L4 9.87V14.48L6.26 15.48V9.57L16.59 7.49Z" fill="url(#paint0_linear_3247_31)"/>
<defs>
<linearGradient id="paint0_linear_3247_31" x1="12" y1="19.97" x2="12" y2="4.03" gradientUnits="userSpaceOnUse">
<stop stop-color="#0078D4"/>
<stop offset="0.16" stop-color="#1380DA"/>
<stop offset="0.53" stop-color="#3C91E5"/>
<stop offset="0.82" stop-color="#559CEC"/>
<stop offset="1" stop-color="#5EA0EF"/>
</linearGradient>
</defs>
</svg>`;